export interface IPaymentGatewayTransactionDetails {
  id: string;

  /// <summary>
  /// The merchants transaction reference if any
  /// </summary>
  paymentGatewayTransactionReference: string;

  /// <summary>
  /// The merchants transaction id if any
  /// </summary>
  paymentGatewayTransactionId: string;

  /// <summary>
  /// Currency as acronym/abbreviation
  /// </summary>
  currency: string;

  amount: number;

  /// <summary>
  /// Date the transaction was successful
  /// </summary>
  paidAt?: Date;

  createdAt: Date;

  paymentUrl: string;
}
